let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kggrq")).then(() => parcelRequire('95FS8'));